import { ApiResource } from './api-resource';
import { Type } from '@angular/core';
import { getFields } from '../util/components/resource/resource-fields/resource-fields.util';

export function castDataToEntity<T extends ApiResource<T>>(
  entityType: Type<T>,
  data: any,
): T {
  const base = new entityType(data);
  // Recursively convert the relationships as well
  for (const [field, { type, array }] of Object.entries(
    getFields(entityType),
  )) {
    let resolvedType: Type<any> | undefined = undefined;
    try {
      resolvedType = type();
    } catch {}
    if (
      !data[field] ||
      !(resolvedType?.prototype instanceof ApiResource) ||
      (array && !Array.isArray(data[field]))
    )
      continue;
    base[field as keyof T] = (
      array ? castDataArrayToEntityArray : castDataToEntity
    )(resolvedType, data[field]);
  }
  return base;
}

// todo: make this recursive
export function castDataArrayToEntityArray<T extends ApiResource<T>>(
  entityType: Type<T>,
  data: any[],
): T[] {
  return data.map((item) => (item ? castDataToEntity(entityType, item) : item));
}
